
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { PeriodDropdown, ReviewQuestionList, StandardPhraseList } from '@/api/openapi';
import Pagination from '@/components/Pagination.vue';
import { parsePagination } from '@/utils';

import ReviewQuestionModal from '@/components/reviewquestions/ReviewQuestionModal.vue';
import StandardPhraseModal from '@/components/standardphrases/StandardPhraseModal.vue';

@Component({
  components: { Pagination, ReviewQuestionModal, StandardPhraseModal },
})
export default class ReviewQuestions extends Vue {
  @Action displayError!: (s: string) => void;
  @Action displaySuccess!: (s: string) => void;
  @Getter loggedInUserHasAnyPermission: any;

  data: Array<ReviewQuestionList> | null = null;
  loading: boolean = true;
  pagination: any | null = null;

  form: {
    period: string | undefined;
  } = {
    period: undefined,
  };

  periods: {
    loading: boolean;
    error: boolean;
    data: Array<PeriodDropdown> | null;
  } = {
    loading: true,
    error: false,
    data: null,
  };

  phrases: {
    loading: boolean;
    data: Array<StandardPhraseList> | null;
    pagination: any | null;
  } = {
    loading: true,
    data: null,
    pagination: null,
  };

  $refs!: {
    questionModal: ReviewQuestionModal;
    phraseModal: StandardPhraseModal;
  };

  async loadList(page?: number, limit?: number) {
    this.loading = true;
    this.data = [];

    try {
      const response = await this.$placementApi.reviewQuestionList({
        page: page || undefined,
        limit: limit || undefined,
        period: this.form.period,
      });

      this.data = response.data;
      this.pagination = parsePagination(response);
    } catch (e) {
      this.$log.error(e);
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
    } finally {
      this.loading = false;
    }
  }

  async loadPeriods() {
    this.periods.loading = true;
    this.periods.data = [];
    this.periods.error = false;

    try {
      const response = await this.$coreApi.periodDropdownList();
      this.periods.data = response.data;
    } catch (e) {
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
      this.periods.error = true;
    } finally {
      this.periods.loading = false;
    }
  }

  async loadPhrases(page?: number, limit?: number) {
    this.phrases.loading = true;
    this.phrases.data = [];

    try {
      const response = await this.$placementApi.standardPhraseList({
        page: page || undefined,
        limit: limit || undefined,
      });

      this.phrases.data = response.data;
      this.phrases.pagination = parsePagination(response);
    } catch (e) {
      this.$log.error(e);
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
    } finally {
      this.phrases.loading = false;
    }
  }

  changeLimit(limit: number) {
    this.loadList(undefined, limit);
  }

  changePage(page: number) {
    this.loadList(page, this.pagination.currentLimit);
  }

  changePhraseLimit(limit: number) {
    this.loadPhrases(undefined, limit);
  }

  changePhrasePage(page: number) {
    this.loadPhrases(page, this.phrases.pagination.currentLimit);
  }

  async deletePhrase(id: string) {
    const conf = confirm('Ertu viss um að þú viljir eyða stöðluðum texta?'); //eslint-disable-line
    if (!conf) return;

    try {
      await this.$placementApi.standardPhrasePartialUpdate({
        uuid: id,
        patchedStandardPhraseDetailUpdateRequest: { isDeleted: true },
      });
      this.displaySuccess(`Staðlaður texti hefur verið eytt.`);
      this.loadPhrases();
    } catch (e) {
      this.$log.error(e);
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
    }
  }

  async created() {
    this.loadPeriods();
    this.loadList();
    this.loadPhrases();
  }

  showQuestionModal(id?: string) {
    this.$refs.questionModal.show(id);
  }

  showPhraseModal(id?: string) {
    this.$refs.phraseModal.show(id);
  }
}
